import React from "react";
import classNames from "classnames";

import * as Assets from "../../assets";
import classes from "./Loader.module.scss";

interface IProps {
	className?: string;
	text?: string;
	isDark?: boolean;
}

export const Loader = ({ className, text, isDark }: IProps): JSX.Element => (
	<div className={classNames(classes.loader, className)} >
		<img src={isDark ? Assets.LoadingDark : Assets.Loading} alt={"loading"} />
		{!!text && (<span>{text}...</span>)}
	</div>
);
